export const getError = ({ auth }) => auth.errors;
export const getErrorPassword = ({ auth }) => auth.errorsPas.password;
export const getAuth = ({ auth }) => auth.isAuthenticated;
export const getLoginLoading = ({ auth }) => auth.loaders.common;
export const getResetLoading = ({ auth }) => auth.loaders.password;
export const getSuccessReset = ({ auth }) => auth.success.reset;
export const getSuccessChanging = ({ auth }) => auth.success.changing;
